export class DealerInterest {
  constructor({
    id = 0,
    scheduleDate = null,
    firstName = null,
    lastName = null,
    fullName = null,
    acn = null,
    address = null,
    telephone = null,
    contactName = null,
    salesRegion = null,
    salesObjectives = null,
    dealerName = null,
    mobileNo = null,
    referrer = null,
    email = null,
    currentBusiness = null,
    refDealerId = null,
    password = null,
    suburb = null,
    state = null,
    postcode = null,
    authToken = null,
    relationShipStatus = null,
    approved = null,
    rejected = null,
    salesForceID = null,
  } = {}) {
    this.id = id;
    this.scheduleDate = scheduleDate;
    this.firstName = firstName;
    this.lastName = lastName;
    this.fullName = fullName;
    this.acn = acn;
    this.address = address;
    this.telephone = telephone;
    this.contactName = contactName;
    this.salesRegion = salesRegion;
    this.salesObjectives = salesObjectives;
    this.dealerName = dealerName;
    this.mobileNo = mobileNo;
    this.referrer = referrer;
    this.email = email;
    this.currentBusiness = currentBusiness;
    this.refDealerId = refDealerId;
    this.password = password;
    this.suburb = suburb;
    this.state = state;
    this.postcode = postcode;
    this.authToken = authToken;
    this.relationShipStatus = relationShipStatus;
    this.approved = approved;
    this.rejected = rejected;
    this.salesForceID = salesForceID;
  }
}
export function createDealerInterest(data) {
  return Object.freeze(new DealerInterest(data));
}
